import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=4a11444b&"
import script from "./HeaderPage.vue?vue&type=script&lang=js&"
export * from "./HeaderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/johnbenedictc.legaspi/Documents/Consultancy/ideaforma-master/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout})
